import loadComponents from './components';
import loadPlugins from './plugins';

loadComponents();
loadPlugins();
